// cspell:disable
import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type PackingTemplateId = ID<"packingTemplate">;
export const packingTemplateIdFormat = idFormat<PackingTemplateId>({
  prefix: "pkt_",
});

export type PrintProfileId = ID<"printProfile">;
export const printProfileIdFormat = idFormat<PrintProfileId>({
  prefix: "prpf_",
});

export type ShippingLabelTemplateId = ID<"shippingLabelTemplate">;
export const shippingLabelTemplateIdFormat = idFormat<ShippingLabelTemplateId>({
  prefix: "shlt_",
});

export type ProductConversionSessionId = ID<"productConversionSession">;
export const productConversionSessionIdFormat =
  idFormat<ProductConversionSessionId>({ prefix: "pcs_" });

export type ProductConversionSessionLineId = ID<"productConversionSessionLine">;
export const productConversionSessionLineIdFormat =
  idFormat<ProductConversionSessionLineId>({ prefix: "pcl_" });

export type BillOfMaterialsId = ID<"billOfMaterials">;
export const billOfMaterialsIdFormat = idFormat<BillOfMaterialsId>({
  prefix: "bom_",
});

export type BillOfMaterialsLocationId = ID<"billOfMaterialsLocation">;
export const billOfMaterialsLocationIdFormat =
  idFormat<BillOfMaterialsLocationId>({ prefix: "boml_" });

export type BillOfMaterialsTemplateId = ID<"billOfMaterialsTemplate">;
export const billOfMaterialsTemplateIdFormat =
  idFormat<BillOfMaterialsTemplateId>({ prefix: "bomt_" });

export type BillOfMaterialsTemplateBindingId =
  ID<"billOfMaterialsTemplateBinding">;
export const billOfMaterialsTemplateBindingIdFormat =
  idFormat<BillOfMaterialsTemplateBindingId>({ prefix: "bomtb_" });

export type WorkOrderId = ID<"workOrder">;
export const workOrderIdFormat = idFormat<WorkOrderId>({ prefix: "wo_" });

export type WorkOrderStepId = ID<"workOrderStep">;
export const workOrderStepIdFormat = idFormat<WorkOrderStepId>({
  prefix: "wos_",
});

export type WorkOrderPickLineId = ID<"workOrderPickLine">;
export const workOrderPickLineIdFormat = idFormat<WorkOrderPickLineId>({
  prefix: "wpl_",
});

export type FreightBookingId = ID<"freightBooking">;
export const freightBookingIdFormat = idFormat<FreightBookingId>({
  prefix: "fb_",
});

export type FreightPickupWindowId = ID<"freightPickupWindow">;
export const freightPickupWindowIdFormat = idFormat<FreightPickupWindowId>({
  prefix: "fpw_",
});

export type FreightHandlingUnitId = ID<"freightHandlingUnit">;
export const freightHandlingUnitIdFormat = idFormat<FreightHandlingUnitId>({
  prefix: "fhu_",
});

export type FreightPickupAccessorialPresetId =
  ID<"freightPickupAccessorialPreset">;
export const freightPickupAccessorialPresetIdFormat =
  idFormat<FreightPickupAccessorialPresetId>({ prefix: "fpa_" });

export type FreightDeliveryAccessorialPresetId =
  ID<"freightDeliveryAccessorialPreset">;
export const freightDeliveryAccessorialPresetIdFormat =
  idFormat<FreightDeliveryAccessorialPresetId>({ prefix: "fda_" });

export type ShipmentLegId = ID<"shipmentLeg">;
export const shipmentLegIdFormat = idFormat<ShipmentLegId>({ prefix: "shlg_" });

export type ShipmentLegParcelId = ID<"shipmentLegParcel">;
export const shipmentLegParcelIdFormat = idFormat<ShipmentLegParcelId>({
  prefix: "shlgp_",
});

export type ShipmentTrackerId = ID<"shipmentTracker">;
export const shipmentTrackerIdFormat = idFormat<ShipmentTrackerId>({
  prefix: "shtrk_",
});

export type AllowedProblemPickPolicyId = ID<"allowedProblemPickPolicy">;
export const allowedProblemPickPolicyIdFormat =
  idFormat<AllowedProblemPickPolicyId>({ prefix: "appp_" });

export type ParcelPhotoId = ID<"parcelPhoto">;
export const parcelPhotoIdFormat = idFormat<ParcelPhotoId>({ prefix: "pph_" });

export type CarrierRateChangeSetId = ID<"carrierRateChangeSet">;
export const carrierRateChangeSetIdFormat = idFormat<CarrierRateChangeSetId>({
  prefix: "crcs_",
});

export type CarrierRateSourceDocumentId = ID<"carrierRateSourceDocument">;
export const carrierRateSourceDocumentIdFormat =
  idFormat<CarrierRateSourceDocumentId>({ prefix: "crsd_" });

export type CarrierRateRecordId = ID<"carrierRateRecord">;
export const carrierRateRecordIdFormat = idFormat<CarrierRateRecordId>({
  prefix: "crr_",
});
